import {Box, styled} from '@mui/material';
import {designSystemToken} from '@lightricks/react-design-system';

const baseContainerStyles = () => ({
  boxSizing: 'border-box' as const,
  backgroundColor: designSystemToken('semantic.bg.secondary'),
  borderRadius: '32px',
  border: `1px solid ${designSystemToken('semantic.bg.neutral-secondary')}`,
});

const FullHeightEditorContainer = styled(Box)(() => ({
  ...baseContainerStyles(),
  width: '100%',
  height: '100%',
  minHeight: 0,
  minWidth: 0,
  overflow: 'hidden',
}));

export default FullHeightEditorContainer;
